import axios from "axios";

function toYmd(value) {
  if (!value) return undefined;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function buildParams(filters) {
  const params = {};
  const dates =
    filters && Array.isArray(filters.date) && filters.date.length
      ? [...filters.date].sort((a, b) => new Date(a) - new Date(b))
      : [];
  if (dates.length) {
    params.start_date = toYmd(dates[0]);
    params.end_date = toYmd(dates[dates.length - 1]);
  }
  if (filters && filters.species && filters.species.length) {
    params.species = filters.species.join(";");
  }
  if (filters && filters.sightingType && filters.sightingType.length) {
    params.sighting_type = filters.sightingType.join(";");
  }
  if (filters && filters.behaviour && filters.behaviour.length) {
    params.behaviour = filters.behaviour.join(";");
  }
  if (filters && filters.onEffort) {
    params.on_effort = true;
  }
  return params;
}

export default {
  async summary(filters) {
    try {
      const response = await axios.get("/analytics/summary", { params: buildParams(filters) });
      return { data: response.data };
    } catch (e) {
      return { data: null };
    }
  },
  async spatial(filters) {
    try {
      const response = await axios.get("/analytics/spatial", { params: buildParams(filters) });
      return { data: response.data };
    } catch (e) {
      return { data: { total: 0, points: [] } };
    }
  },
};
